import React from 'react';
import { MailIcon, PhoneIcon, ShoppingBagIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-28">
          <div data-id="element-29">
            <div className="flex items-center gap-2 mb-4" data-id="element-30">
              <ShoppingBagIcon className="w-8 h-8 text-green-400" data-id="element-31" />
              <span className="text-2xl font-bold" data-id="element-32">Lola</span>
            </div>
            <p className="text-gray-400" data-id="element-33">
              Turn everyday purchases into health outcomes for Food-as-Medicine
              platforms.
            </p>
          </div>

          <div data-id="element-34">
            <h3 className="font-bold text-lg mb-4" data-id="element-35">Platform</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-36">
              <li data-id="element-37">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-38">
                  API Documentation
                </a>
              </li>
              <li data-id="element-39">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-40">
                  Integration Guide
                </a>
              </li>
              <li data-id="element-41">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-42">
                  Case Studies
                </a>
              </li>
              <li data-id="element-43">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-44">
                  Partner Demo
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-45">
            <h3 className="font-bold text-lg mb-4" data-id="element-46">Partners</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-47">
              <li data-id="element-48">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-49">
                  FAM Providers
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-51">
                  Health Plans
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-53">
                  Retailers
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-55">
                  Become a Partner
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-56">
            <h3 className="font-bold text-lg mb-4" data-id="element-57">Contact</h3>
            <ul className="space-y-3 text-gray-400" data-id="element-58">
              <li className="flex items-center gap-2" data-id="element-59">
                <MailIcon className="w-5 h-5 text-green-400" data-id="element-60" />
                <a href="mailto:partners@lola.health" className="hover:text-green-400 transition-colors" data-id="element-61">
                  partners@lola.health
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-62">
                <PhoneIcon className="w-5 h-5 text-green-400" data-id="element-63" />
                <a href="tel:+1234567890" className="hover:text-green-400 transition-colors" data-id="element-64">
                  (123) 456-7890
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-65">
          <p data-id="element-66">&copy; 2024 Lola Health. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}